export default __webpack_public_path__ + "static/media/Sid Lee - New Logo2.e1a755e6.png";